import { WinePackageWidgetModel } from 'shared-widget-components/src/services/FeaturedPackagesService';
import { convert as urlSlug } from 'url-slug';

const useWinePackageUrl = ({ winePackage }: { winePackage: WinePackageWidgetModel }) => {
  // @ts-ignore
  const languageCode = window.currentLanguageCode;

  const createUrl = (winePackageId: number, packageName: string, languageCode: string) => {
    const domain = getPackageDomain(languageCode);

    const slug = urlSlug(packageName);

    return `/${domain}/${winePackageId}/${slug}`;
  };

  const getPackageDomain = (languageCode: string): string => {
    switch (languageCode) {
      case 'en':
        return 'winepackages';
      case 'de':
        return 'weinpaket';
      case 'pl':
        return 'pakiety-win';
      case 'hu':
      default:
        return 'borcsomagok';
    }
  };

  const url = createUrl(winePackage.productVariantId, winePackage.title, languageCode);

  // navigate to the package when the image is clicked
  const onPackageClick = () => {
    // @ts-ignore
    if (window.isAdminPage) return;

    window.location.href = url;
  };
  return { onPackageClick };
};

export default useWinePackageUrl;
